<!--
 * @Author: DY
 * @Date: 2024-12-11 16:58:44
 * @LastEditTime: 2025-04-01 13:59:13
 * @Description: 选择列表
 * @FilePath: \ShiMo_Mobile\src\components\selectList\index_list.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="listView commonListStyles">
            <HeaderNav
                :header-title="parameter.pageTitle"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @search="onRefresh" @clear="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li
                                class="listItem"
                                v-for="(item, index) in listData"
                                :key="`item_${index}`"
                                :class="{ 'listItem_select': selectIDs.includes(item[parameter.relationKey]) }"
                                @click="selectList(item)"
                            >
                                <div class="engineeringInfo">
                                    <div class="itemContent">
                                        <template v-for="(k, j) in parameter.headerList">
                                            <template v-if="k.isTitle">
                                                <p :key="`itemTerm_${j}`" class="itemTitle">
                                                    <van-icon class="selectIcon" name="checked"></van-icon>
                                                    <span>{{ k.name }}：{{ item[k.code] }}</span>
                                                </p>
                                            </template>
                                            <template v-else>
                                                <p :key="`itemTerm_${j}`">
                                                    <img v-if="k.icon" :src="require(`@/assets/images/icons/${k.icon}.png`)">
                                                    <span>{{ k.name }}：{{ item[k.code] }}</span>
                                                </p>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <footer class="currencyFooterStyle">
                <div class="totalBox" v-if="parameter.showTotal || parameter.totalKey !== ''">
                    <van-checkbox v-model="selectAll" checked-color="#ee0a24" v-if="parameter.showTotal" @click="selectAllChange">
                        全选
                    </van-checkbox>
                    <div class="total" v-if="parameter.totalKey !== ''">
                        合计：<span>{{ totalNub }}</span>
                    </div>
                </div>
                <button class="confirm" @click="confirmSelection">
                    确认选择
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    name: 'list-view',
    components: {
        HeaderNav,
    },
    data() {
        return {
            parameter: {
                pageTitle: '选择列表',
                sourcePath: '/home',
                type: 'radio',
                listCode: '',
                indexKey: 'PageIndex',
                sizeKey: 'PageSize',
                SearchKey: 'SearchKey',
                pageIndex: 0,
                pageSize: 5,
                initIndex: 0,
                requestUrl: '/basicplatform/tabledata',
                requestType: 'post',
                headerList: [],
                tableList: [],
                callbackDataKey: '',
                relationKey: 'id',
                searchKey: 'searchKey',
                showTotal: false,
                totalKey: '',
            },
            keyVal: '',
            isUpLoading: false,
            isLoading: false,
            finished: false,
            listData: [],
            selectIDs: [],
            selectAll: false,
            totalNub: 0,
        };
    },
    watch: {},
    created() {
        this.initPage();
    },
    mounted() {},
    computed: {},
    methods: {
        async initPage() {
            this.parameter = Object.assign(this.parameter, this.$route.params);
            this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
        },
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: this.parameter.sourcePath });
        },
        // 下拉刷新
        onRefresh() {
            this.parameter.pageIndex = JSON.parse(JSON.stringify(this.parameter.initIndex));
            this.listData = [];
            this.isLoading = false;
            this.finished = false;
            this.loadListData();
        },
        onLoad() {
            this.loadListData();
            this.parameter.pageIndex++;
        },
        loadRequestData() {
            return {
                cacheKey: this.cacheKey,
                code: this.parameter.listCode,
                [this.parameter.indexKey]: this.parameter.pageIndex,
                [this.parameter.sizeKey]: this.parameter.pageSize,
                [this.parameter.searchKey]: this.keyVal,
            };
        },
        selectList(item) {
            if (!this.selectIDs.includes(item[this.parameter.relationKey])) {
                if (this.parameter.type === 'radio') {
                    this.selectIDs = [item[this.parameter.relationKey]];
                } else {
                    this.selectIDs.push(item[this.parameter.relationKey]);
                    if (this.parameter.showTotal) {
                        if (this.selectIDs.length === this.listData.length) {
                            this.selectAll = true;
                        }
                    }
                }
            } else {
                const index = this.selectIDs.findIndex(k => k === item[this.parameter.relationKey]);
                this.selectIDs.splice(index, 1);
                if (this.parameter.showTotal) {
                    if (this.selectIDs.length !== this.listData.length) {
                        this.selectAll = false;
                    }
                }
            }
            this.loadTotalNub();
        },
        selectAllChange() {
            if (this.selectAll) {
                this.selectIDs = this.listData.map(item => item[this.parameter.relationKey]);
            } else {
                this.selectIDs = [];
            }
            this.loadTotalNub();
        },
        loadTotalNub() {
            if ((this.parameter.totalKey || '') === '') { return; }
            this.totalNub = this.listData.filter(item => this.selectIDs.includes(item[this.parameter.relationKey]))
                .map(item => item[this.parameter.totalKey])
                .reduce((accumulator, currentValue) => NP.plus(accumulator || 0, currentValue || 0), 0);
        },
        confirmSelection() {
            const data = this.listData.filter(item => this.selectIDs.includes(item[this.parameter.relationKey]));
            if ((data || []).length > 0) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.parameter.sourcePath,
                    params: {
                        [this.parameter.callbackDataKey]: data,
                    },
                });
            } else {
                this.$toast.fail('请先选择列表数据！');
            }
        },
        async loadListData() {
            if (this.parameter.requestType === 'post') {
                const requestData = this.loadRequestData();
                const res = await this.getListData_post(this.parameter.requestUrl, requestData);
                if (requestData[this.parameter.indexKey] === this.parameter.initIndex) {
                    this.listData = res.rows;
                } else {
                    this.listData.push(...res.rows);
                }
                if (res.total <= this.listData.length) {
                    this.finished = true;
                }
                this.isLoading = false;
                this.isUpLoading = false;
            } else if (this.parameter.requestType === 'get') {
                let requestUrl = this.parameter.requestUrl;
                if ((this.keyVal || '') !== '') {
                    if (this.parameter.requestUrl.includes('?')) {
                        requestUrl = `${this.parameter.requestUrl}&${this.parameter.SearchKey}=${this.keyVal}`;
                    } else {
                        requestUrl = `${this.parameter.requestUrl}?${this.parameter.SearchKey}=${this.keyVal}`;
                    }
                }
                const res = await this.getListData_get(requestUrl);
                this.listData = this.parameter.rowsKey && res ? res[this.parameter.rowsKey] : res;
                this.finished = true;
            }
        },
        getListData_post(requestUrl, requestData) {
            return this.$axios.$post(`/interfaceApi${requestUrl}`, requestData, { token: this.parameter.newsToken });
        },
        getListData_get(requestUrl) {
            return this.$axios.$get(`/interfaceApi${requestUrl}`, { token: this.parameter.newsToken });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.listView
    section
        display: flex;
        flex-direction: column;
        .listItem
            &.listItem_select
                box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2), inset 0px 0px 20px 0px rgba(233,55,67,0.5);
                border: 1px solid #FF8C91 !important
                .itemTitle
                    border-bottom 1px solid #FFE8E9
                    .selectIcon
                        color #EA4651
        .van-pull-refresh
            height: 0
            flex: 1;
        .engineeringInfo
            .itemContent
                padding 0 !important
            p
                padding 0 12rpx
                margin-bottom: 12rpx !important
                span
                    text-overflow: initial!important
                    white-space: initial!important
                    word-break: break-all;
                    height: auto!important
            .itemTitle
                margin: 0
                height 44rpx
                line-height 38rpx
                padding 6rpx 12rpx 0
                border-bottom 1px solid #E7E6E6
                display flex
                align-items: center
                .selectIcon
                    color #CACACA
                    font-size 18rpx
                    margin-right: 7rpx
    .currencyFooterStyle
        .totalBox
            margin-left: 10rpx
            width calc(100% - 110rpx)
            display: flex
            align-content: center
            justify-content: space-between
            padding: 10rpx 14rpx 10rpx 0
            .total
                font-size 14rpx
                span
                    font-size 20rpx
                    color #EA4651
</style>
